declare const window
interface IJavaScriptInterface {
  enableHeader(): void
  disableHeader(): void
  loadUrl(aString: string): void
}

declare const AndroidDasherClient: IJavaScriptInterface

export const enableHeader = () => {
  AndroidDasherClient.enableHeader()
}

export const disableHeader = () => {
  AndroidDasherClient.disableHeader()
}

/**
 * Loads a URL in the Android device via an app-switch to the browser
 *
 * @param {string} url
 */
export const loadUrl = (url: string) => {
  AndroidDasherClient.loadUrl(url)
}
